import * as yup from 'yup';
import { UserRegisterType } from '../../project-types/users/types';

export const ForgotPasswordSchema: yup.SchemaOf<Omit<UserRegisterType, 'password'>> = yup.object({
  email: yup.string().email('email must be a valid email').defined('email must be a valid email'),
});
